import { siteConfig, IMAGES } from "@/data/siteConfig";
import { Reveal } from "./shared";

export const PillarsSection = () => {
  const { pillars } = siteConfig;
  return (
    <section id="pillars" data-testid="pillars-section" className="bg-cream py-24 lg:py-36">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="max-w-3xl mb-16">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">{pillars.eyebrow}</p>
            <h2 className="font-display text-4xl font-semibold leading-[1.1] tracking-tight text-navy sm:text-5xl">
              {pillars.heading}
            </h2>
          </Reveal>
        </div>

        <div className="grid gap-px border border-navy/10 bg-navy/10 sm:grid-cols-2 lg:grid-cols-3">
          {pillars.items.map((p, i) => (
            <Reveal key={p.n} delay={(i % 3) * 0.08} className="group bg-cream p-10 lg:p-12 transition-colors duration-500 hover:bg-navy">
              <div className="flex items-start justify-between mb-10">
                <span className="font-display text-lg text-gold">{p.n}</span>
                <span className="h-8 w-8 border border-navy/20 group-hover:border-gold transition-colors duration-500" />
              </div>
              <h3 className="font-display text-2xl text-navy mb-4 transition-colors duration-500 group-hover:text-cream lg:text-3xl">
                {p.title}
              </h3>
              <p className="text-base leading-relaxed text-charcoal/75 transition-colors duration-500 group-hover:text-cream/70">
                {p.body}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export const ScholarPathwaySection = () => {
  const { pathway } = siteConfig;
  return (
    <section id="pathway" data-testid="pathway-section" className="bg-charcoal py-24 lg:py-36 grain relative overflow-hidden">
      <div className="relative z-10 mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid gap-16 lg:grid-cols-12 lg:gap-20">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">{pathway.eyebrow}</p>
              <h2 className="font-display text-4xl font-semibold leading-[1.1] tracking-tight text-cream sm:text-5xl">
                {pathway.heading}
              </h2>
              <p className="mt-8 text-lg leading-relaxed text-cream/70">{pathway.forWhom}</p>
              <div className="mt-10 overflow-hidden">
                <img src={IMAGES.study} alt="Scholars studying together" className="w-full h-64 object-cover" />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-6 lg:col-start-7 grid gap-12">
            <Reveal delay={0.1}>
              <h3 className="text-xs uppercase tracking-[0.3em] text-cream/50 mb-6">What scholars receive</h3>
              <ul className="divide-y divide-white/10">
                {pathway.receive.map((r, i) => (
                  <li key={i} className="flex gap-6 py-4 text-cream">
                    <span className="font-display text-gold">{String(i + 1).padStart(2, "0")}</span>
                    <span className="text-lg">{r}</span>
                  </li>
                ))}
              </ul>
            </Reveal>
            <Reveal delay={0.15}>
              <h3 className="text-xs uppercase tracking-[0.3em] text-cream/50 mb-6">What we expect</h3>
              <ul className="divide-y divide-white/10">
                {pathway.expect.map((r, i) => (
                  <li key={i} className="flex gap-6 py-4 text-cream/85">
                    <span className="font-display text-gold">{String(i + 1).padStart(2, "0")}</span>
                    <span className="text-lg">{r}</span>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
